import { render, staticRenderFns } from "./SynonymsRussianLanguageForm.vue?vue&type=template&id=c7fa7498&scoped=true&lang=pug&"
import script from "./SynonymsRussianLanguageForm.vue?vue&type=script&lang=js&"
export * from "./SynonymsRussianLanguageForm.vue?vue&type=script&lang=js&"
import style0 from "./SynonymsRussianLanguageForm.vue?vue&type=style&index=0&id=c7fa7498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fa7498",
  null
  
)

export default component.exports